import { BriefingStyleStateEnum } from '../../../Common/MonitorShared/enum/briefing-style-state.enum';
import { TextStyleModel } from '../../../Common/PageBuilder/models/text-style.model';
import { StyleStateEnum } from '../../../Common/PageBuilder/enums/style-state.enum';

export const defaultFontFamily: string = 'Arial, Helvetica, sans-serif';

export class MonitoringTextStyleModel extends TextStyleModel {
    constructor(apiModel?: any) {
        super(apiModel);
        if (!this.styleState || this.styleState === StyleStateEnum.DEFAULT) {
            this.styleState = BriefingStyleStateEnum.BRIEFING_1;
        }
        if (!this.displayStyleState || this.displayStyleState === StyleStateEnum.DEFAULT) {
            this.displayStyleState = this.styleState;
        }
        if (
            (
                !this.defaultReference ||
                this.defaultReference === StyleStateEnum.DEFAULT
            ) &&
            typeof this.styleState === 'string'
        ) {
            // Legacy data may not have default reference set, if the styleState is custom and there's no default reference, the default reference
            // should be BRIEFING_1 because it must have been created back when there was only one default
            this.defaultReference = this.styleState !== StyleStateEnum.CUSTOM ? this.styleState as string : BriefingStyleStateEnum.BRIEFING_1;
        }
    }


    clone(): MonitoringTextStyleModel {
        const clone = new MonitoringTextStyleModel(
            {
                color: this.color,
                fontFamily: this.fontFamily,
                fontSize: this.fontSize,
                bold: this.bold,
                italics: this.italics,
                underlined: this.underlined,
                alignment: this.alignment,
                styleState: this.styleState,
                displayStyleState: this.displayStyleState,
                defaultReference: this.defaultReference ? this.defaultReference : BriefingStyleStateEnum.BRIEFING_1,
                backgroundColor: this.backgroundColor,
                padding: this.padding
            }
        );

        if (this.template) {
            clone.template = this.template.clone();
        }

        return clone;
    }

    toApi(): any {
        return {
            color: this.color,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            bold: this.bold,
            italics: this.italics,
            underlined: this.underlined,
            alignment: this.alignment,
            defaultReference: this.defaultReference ? this.defaultReference : BriefingStyleStateEnum.BRIEFING_1,
            backgroundColor: this.backgroundColor,
            padding: this.padding
        };
    }
}
